import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    title: {
        fontSize: theme.typography.pxToRem(22),
        paddingBottom: theme.spacing(2.5),
    },
    divider: {
        marginBottom: theme.spacing(2.5),
    },
}));
